import { Component, OnInit, ViewChild } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
// import { ApiService } from '../../services/api.service';
import { StateService } from '@uirouter/angular';
import { FrontEndService } from '../../services/front-end.service';
// import { LoginSignupComponent} from '../login-signup/login-signup.component';
import { inject } from '@angular/core/testing';

@Component({
  selector: 'app-intro-with-banner',
  templateUrl: './intro-with-banner.component.html',
  styleUrls: ['./intro-with-banner.component.scss']
})

export class IntroWithBannerComponent implements OnInit {
  closeResult : any;

  // activeTab = "login";
  // loginForm = {
  //   // "username": "",
  //   // "password": ""
  // };
  // signForm = {
  //
  // }


  constructor(
    private modalService: NgbModal,
    private frontEndService: FrontEndService ,
    // private parent: LoginSignupComponent
    // private apiService: ApiService
  ) {}

  ngOnInit() {
      //this.logService.printLog(this.parent.activeTab);
      
  }

  // onSubmit() {
  //   // this.logService.printLog("Login form data", this.loginForm);
  //   this.apiService.login(this.loginForm, function(response) {
  //     // this.logService.printLog("Login response received");
  //   })
  //
  // }
  // onSignupSubmit(){
  //   // this.logService.printLog("sign form data", this.signForm);
  //   this.apiService.signup(this.signForm, function(response) {
  //   //  this.logService.printLog("signup response received");
  //  })
  // }


  // openModal(content, type) {
  //   // this.activeTab = type;
  //   this.open(content);
  // }

  // open(content) {
  //     this.modalService.open(content).result.then((result) => {
  //       this.closeResult = `Closed with: ${result}`;
  //     }, (reason) => {
  //       this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  //     });
  //   }
  // private getDismissReason(reason: any): string {
  //     if (reason === ModalDismissReasons.ESC) {
  //       return 'by pressing ESC';
  //     } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
  //       return 'by clicking on a backdrop';
  //     } else {
  //       return  `with: ${reason}`;
  //     }
  //   }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/intro-with-banner/intro-with-banner.component.ts